module.exports = __webpack_public_path__ + "img/Patent_9.cf8facaa.jpg";